// extracted by mini-css-extract-plugin
export var actions = "_rt-4";
export var item = "_rt-1";
export var price = "_rt-3";
export var quantity = "_rt-2";
export var table = "_rt-0";